module.exports = __webpack_public_path__ + "static/img/SourceSansPro-SemiBoldItalic.748355e.svg";